(function(){
 'use strict';
 const node=document.getElementById('dd-resale-config');
 if(!node||!window.DeeDentalResaleCart)return;
 const config=JSON.parse(node.textContent),mapping=Object.assign({},config.map);
 delete mapping['0'];
 // When the account/location changes, return former exempt items to their
 // normal counterparts unless the current location still has this scope.
 for(const [target,source] of Object.entries(config.reverse))if(mapping[source]!==target)mapping[target]=source;
 const root=window.Shopify?.routes?.root||'/';
 async function request(path,body){
   const response=await fetch(root+path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify(body):undefined});
   const value=await response.json();
   if(!response.ok||value.status>=400)throw Error(value.description||'Please review your cart and try again.');
   return value;
 }
 const reconcile=window.DeeDentalResaleCart.reconciler({read:()=>request('cart.js'),update:updates=>request('cart/update.js',{updates})});
 let busy=false;
 function message(text){
   let box=document.getElementById('dd-resale-message');
   if(!box){box=document.createElement('div');box.id='dd-resale-message';box.setAttribute('role','alert');box.style.cssText='position:fixed;bottom:20px;left:20px;right:20px;z-index:10000;padding:16px;background:#fff;border:2px solid #125da5;color:#193651';document.body.append(box);}
   box.textContent=text;
 }
 async function checkout(){
   if(busy)return;busy=true;
   try{await reconcile(mapping);window.location.assign(root+'checkout');}
   catch(e){message(e.message+' / 장바구니를 확인한 후 다시 시도해 주세요.');busy=false;}
 }
 window.DeeDentalResale={variant:id=>String(mapping[String(id)]||id),reconcile:()=>reconcile(mapping)};
 document.addEventListener('submit',function(event){
   const form=event.target,button=event.submitter;
   if(button?.name==='checkout'||form.matches?.('form[action$="/checkout"]')){event.preventDefault();event.stopImmediatePropagation();checkout();}
 },true);
 document.addEventListener('click',function(event){
   const a=event.target.closest?.('a[href]');
   if(a){const url=new URL(a.href,location.href);if(url.origin===location.origin&&url.pathname.replace(/\/$/,'')===root.replace(/\/$/,'')+'/checkout'){event.preventDefault();event.stopImmediatePropagation();checkout();}}
 },true);
 // Update a cart created before login, so its displayed rows match checkout.
 if(location.pathname.replace(/\/$/,'')===root.replace(/\/$/,'')+'/cart'){
   request('cart.js').then(cart=>{if(window.DeeDentalResaleCart.plan(cart,mapping).changed)return reconcile(mapping).then(()=>location.reload());}).catch(e=>message(e.message));
 }
})();
